<div
    class="cmps-cdk-border-tl-radius-8p cmps-cdk-border-tr-radius-8p cmps-cdk-border-width-2p cmps-cdk-border-solid cmps-cdk-border-color-blue-100 cmps-cdk-bg-color-blue-100 cmps-cdk-d-flex cmps-cdk-flex-column cmps-cdk-px-0dot5 cmps-cdk-color-white"
>
    <div class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-min-h-34p">
        <div class="cmps-cdk-font-size-15p cmps-cdk-mr-0dot25">
            {{ _i18n._9422_BEHAVIOUR_ | translate }}
        </div>
        <div class="cmps-cdk-font-size-15p cmps-cdk-flex-grow-1">
            {{
                _service.state?.primaryFocusTag?.behaviour?.name ??
                    (_i18n._9986_NO_BEHAVIOUR_SELECTED | translate)
            }}
        </div>
        <div>
            <button
                cmpsIconButton
                class="cmps-icon-button--no-bg--white"
                [disabled]="!_service.state?.allowedActions?.editTranscript"
                (click)="
                    !forNotes ? _onEditFocusClick() : _onEditNotesFocusClick()
                "
            >
                <cmps-icon svgIcon="pencil"></cmps-icon>
            </button>
        </div>
    </div>
    <div
        class="cmps-cdk-d-flex cmps-cdk-flex-wrap"
        *ngIf="!forNotes"
    >
        <ng-container *ngFor="let tag of _service.state?.behaviourTags">
            <button
                class="cmps-outline-button--sm cmps-cdk-mr-0dot5 cmps-cdk-mb-0dot5"
                cmpsOutlineButton
                [disabled]="!_service.state?.allowedActions?.editTranscript"
                (click)="_onRemoveBehaviourClick(tag)"
            >
                <span cmpsOutlineButtonLabel>{{
                    tag?.behaviour?.shortName
                }}</span>
                <cmps-icon
                    svgIcon="close"
                    *ngIf="_service.state?.allowedActions?.editTranscript"
                ></cmps-icon>
            </button>
        </ng-container>
        <button
            class="cmps-outline-button--sm cmps-cdk-mb-0dot5"
            cmpsOutlineButton
            (click)="_onAddBehaviourClick()"
            *ngIf="_service.state?.allowedActions?.editTranscript"
        >
            <cmps-icon svgIcon="plus"></cmps-icon>
            <span cmpsOutlineButtonLabel>{{
                _i18n._10016_ADD_BEHAVIOUR | translate
            }}</span>
        </button>
    </div>
</div>
<div
    class="cmps-cdk-border-bl-radius-8p cmps-cdk-border-br-radius-8p cmps-cdk-border-width-2p cmps-cdk-border-solid cmps-cdk-border-color-blue-100 cmps-cdk-bg-color-white cmps-cdk-d-flex cmps-cdk-p-0dot5"
>
    <div class="cmps-cdk-font-size-15p cmps-cdk-mr-0dot25">
        {{ _i18n._9423_SUB_BEHAVIOUR_ | translate }}
    </div>
    <div class="cmps-cdk-font-size-15p">
        {{
            _service.state?.primaryFocusTag?.subBehaviour?.name ??
                (_i18n._9987_NO_SUB_BEHAVIOUR_SELECTED | translate)
        }}
    </div>
</div>
